function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React, { useMemo } from "react";
import { NumericFormat } from "react-number-format";
import { CurrencyFormInput } from "../../../atoms";
import LegacySimulatorAction from "../LegacySimulatorAction";
var StepTotalAmount = function(param) {
    var t = param.t, stepState = param.stepState, amountState = param.amountState;
    var _amountState = _sliced_to_array(amountState, 2), totalAmount = _amountState[0], setTotalAmount = _amountState[1];
    var onChange = function(data) {
        if (data.floatValue) {
            setTotalAmount(data.floatValue);
        }
    };
    var canContinue = useMemo(function() {
        return !!totalAmount;
    }, [
        totalAmount
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-col items-center justify-center w-full h-auto gap-4"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex items-center justify-center mt-6 mb-8"
    }, /*#__PURE__*/ React.createElement(NumericFormat, {
        value: totalAmount ? totalAmount.toString() : "",
        onValueChange: onChange,
        inputClasses: "p-6 pr-11 w-full md:w-96 text-body-base font-semibold rounded-xl",
        withSuffix: "euros",
        customInput: CurrencyFormInput,
        thousandSeparator: " "
    })), /*#__PURE__*/ React.createElement(LegacySimulatorAction, {
        t: t,
        stepState: stepState,
        canContinue: canContinue
    }));
};
export default StepTotalAmount;

//# sourceMappingURL=StepTotalAmount.js.map